import apiService from "../common/commonApi";

export const project = {};

project.list = async (param) => {    
    return apiService.Get('project-list', param);
}

project.add = async (param) => {    
    return apiService.Post('project-create', param);
}

project.delete = async (param) => {    
    return apiService.Post('project-delete', param);
}

project.update = async (param) => {    
    return apiService.Post('project-update', param);
}
